'use strict';
import {DOM} from '../../../../../plugins/levcharity/resources/scripts/helpers/DOM.js';


export class FAQ{
    dashboardContainer
    constructor() {
        this.handleQuestion()
        this.dashboardContainer = DOM.el('.chaiathon-dashboard-container');
    }


    handleQuestion() {
        const faqWrapper = DOM.el('.faq-wrapper', this.dashboardContainer);
        const faqItems = DOM.els('.faq-item', faqWrapper);

        faqItems?.forEach((item) => {
            let arrowDown = DOM.el('.arrow-dropdown', item);
            let answer = DOM.el('.answer', item);

            DOM.addEvent('click', item, () => {
                const isOpen = answer.classList.contains('opened');

                faqItems.forEach((el) => {
                    el.classList.remove('active');
                    let ans = DOM.el('.answer', el);
                    ans.classList.remove('opened');
                    ans.classList.add('closed');
                });

                if (!isOpen) {
                    answer.classList.remove('closed');
                    answer.classList.add('opened');
                    item.classList.add('active');
                }
            });
        });
    }

}